import { NavLink, Outlet } from 'react-router-dom';

import { cn } from '../../lib/cn';
import { SETTINGS_GROUPS, SETTINGS_NAV } from './navItems';
import styles from './settings.module.css';

export function SettingsLayout() {
  return (
    <div className={styles.layout}>
      <aside className={styles.subnav} aria-label="הגדרות · ניווט משני">
        {SETTINGS_GROUPS.map((group) => {
          const items = SETTINGS_NAV.filter((it) => it.group === group.id);
          if (items.length === 0) return null;
          return (
            <div key={group.id} className={styles.group}>
              <h6 className={styles.groupTitle}>{group.title}</h6>
              {items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.id}
                    to={item.path}
                    className={({ isActive }) =>
                      cn(styles.item, isActive && styles.active, !item.enabled && styles.stub)
                    }
                  >
                    <Icon size={16} className={styles.itemIcon} aria-hidden="true" />
                    <span className={styles.itemLabel}>{item.label}</span>
                    {!item.enabled ? (
                      <span className={styles.itemPhase}>{`P${String(item.phase)}`}</span>
                    ) : null}
                  </NavLink>
                );
              })}
            </div>
          );
        })}
      </aside>

      <section className={styles.content}>
        <Outlet />
      </section>
    </div>
  );
}
